import {
	DisclosureCard,
	IconSquare,
	SPACING as DSSpacing,
} from '@monthio/design-system'
import {
	InderterminateQuestionBox,
	AccountBalance,
	DataCheck,
} from '@monthio/icons'
import {
	FlowStepData,
	FlowStepGroup,
	FlowStepSubGroup,
} from '../../../pages/LandingPage/flowStepUtils'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const DisclosureCardContent = styled.p`
	padding: ${DSSpacing.s} ${DSSpacing.m};
	margin: 0;
`

interface FlowStepDisclosureCardProps {
	idx: number
	flowStep: FlowStepData
	clientName: string
}

export const FlowStepDisclosureCard = ({
	idx,
	flowStep,
	clientName,
}: FlowStepDisclosureCardProps) => {
	const { t } = useTranslation()

	return (
		<DisclosureCard
			startDecorator={AccessibleFlowStepIcon[flowStep.group]}
			title={t(`landingPage-${FlowStepSubGroup[flowStep.subGroup]}-title`)}
			description={t('landingPage-flowStep-count', { count: idx })}
			headingLevel={2}
		>
			<DisclosureCardContent>
				{t(`landingPage-${FlowStepSubGroup[flowStep.subGroup]}-description`, {
					clientName,
				})}
			</DisclosureCardContent>
		</DisclosureCard>
	)
}

const AccessibleFlowStepIcon = {
	[FlowStepGroup.BackgroundInformation]: (
		<IconSquare
			icon={InderterminateQuestionBox}
			/* This is a hack to get custom colors to work. DO NOT repeat elsewhere! */
			backgroundColor={'var(--color-brand-100)'}
			color={'var(--color-brand-500)'}
		/>
	),
	[FlowStepGroup.Data]: (
		<IconSquare
			icon={AccountBalance}
			/* This is a hack to get custom colors to work. DO NOT repeat elsewhere! */
			backgroundColor={'var(--color-brand-100)'}
			color={'var(--color-brand-500)'}
		/>
	),
	[FlowStepGroup.Overview]: (
		<IconSquare
			icon={DataCheck}
			/* This is a hack to get custom colors to work. DO NOT repeat elsewhere! */
			backgroundColor={'var(--color-brand-100)'}
			color={'var(--color-brand-500)'}
		/>
	),
}
